import React from 'react';
import './Footer.scss';
import { navItems } from './footer-nav-items';
import FooterNavItem from './FooterNavItem';
import Icon from 'components/UI/Icon';
const logo = require('theme/logo-small.svg');
function Footer({ hideFaq }) {
    return (React.createElement("footer", { className: "footer-v2" },
        React.createElement("div", { className: "footer-v2__content" },
            React.createElement("div", { className: "footer-v2__top" }, !hideFaq && (React.createElement("ul", { className: "footer-v2__faq" }, navItems.faq.map((v, i) => (React.createElement(FooterNavItem, Object.assign({}, v, { key: i }))))))),
            React.createElement("div", { className: "footer-v2__center" },
                React.createElement("ul", { className: "footer-v2__articles" }, navItems.articles.map((v, i) => (React.createElement(FooterNavItem, Object.assign({}, v, { key: i }))))),
                React.createElement("ul", { className: "footer-v2__social" }, navItems.social.map((v, i) => (React.createElement(FooterNavItem, Object.assign({}, v, { key: i })))))),
            React.createElement("div", { className: "footer-v2__bottom" },
                React.createElement("p", null, process.env.SUPPORT_EMAIL),
                React.createElement(Icon, { svg: logo, size: 'xlarge' })))));
}
export default Footer;
